/* ============================================================
   assets/mj-loyalty.js — marjour ポイント(Loyalty)表示の動的処理
   1) 商品ページ: キャンペーン金枠バナーのライブカウントダウン（[data-mj-countdown]）
   2) マイページ: 残高・履歴を App Proxy から取得して描画（[data-mj-account]）
      GET /apps/nsn-loyalty/balance → { balance, pending, points_expire_at, rank, next_rank, ... }
      GET /apps/nsn-loyalty/history → { history:[...], next_cursor }
   ※ 対象要素が無ければ何もしない（該当ページ以外・データ未投入でも安全）。
   ============================================================ */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }
  // 全角数字→半角に変換（入力欄で全角で打たれても受け付ける）
  function toHalf(s) { return String(s == null ? '' : s).replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); }); }

  /* ---- 1) キャンペーンバナーのカウントダウン ---- */
  function initCountdown(el) {
    el.setAttribute('data-mj-cd', '1');
    var end = new Date((el.getAttribute('data-end') || '').replace(' ', 'T'));
    if (isNaN(end.getTime())) return;
    var box = el.closest('.mj-pointup');
    var timer = null;
    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        if (box) box.style.display = 'none';
        if (timer) clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      el.textContent = '終了まで ' + (d > 0 ? d + '日 ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---- 2) マイページ 残高・履歴 ---- */
  // 履歴1件から表示要素を取り出す（バックエンドのキー名揺れに強く）
  function histAmount(it) {
    var v = (it.amount != null) ? it.amount : (it.points != null) ? it.points : (it.value != null) ? it.value : it.delta;
    return num(v);
  }
  // kind→日本語ラベル。堤さんアプリの確定10 kind（2026-08 仕様）。context は英語内部文字列なので表示しない。
  // 未知の kind はバックエンドのラベル系キー→最後は generic「ポイント」に落とす。
  var HIST_KIND_LABEL = {
    earn: 'ポイント獲得',
    earn_bonus: 'ボーナスポイント',
    earn_reversal: '獲得ポイント取消',
    earn_bonus_reversal: 'ボーナスポイント取消',
    spend: 'ポイント利用',
    spend_reversal: 'ポイント返還',
    adjust: 'ポイント調整',
    signup_bonus: '会員登録ボーナス',
    expire: 'ポイント失効',
    opening: '繰越ポイント'
  };
  function histLabel(it) {
    if (it.kind && HIST_KIND_LABEL[it.kind]) return HIST_KIND_LABEL[it.kind];
    return it.reason || it.label || it.description || it.title || it.type || 'ポイント';
  }
  // status→ラベル後置き（kind と直交）。available は無印。
  function histStatusSuffix(it) {
    if (it.status === 'pending') return '（付与予定）';
    if (it.status === 'cancelled') return '（取り消し）';
    return '';
  }
  function histDate(it) {
    // 「日付」列は発生日(created_at)で統一。pending は event セルの「（付与予定）」で示す。
    // （available_at は成熟予定日のはずだが現状 backend が有効期限相当を返す疑いがあり、日付列には出さない）
    var d = it.date || it.created_at || it.occurred_at || it.createdAt || it.available_at || '';
    return String(d).slice(0, 10); // YYYY-MM-DD
  }
  // "2027-08-12..." → "2027年8月12日"（マイページの注文履歴の日付表記に合わせる）
  function jpDate(s) {
    var m = String(s).slice(0, 10).split('-');
    return (m.length === 3) ? (m[0] + '年' + (+m[1]) + '月' + (+m[2]) + '日') : String(s).slice(0, 10);
  }

  // 残高サマリー（マイページ上部）
  function initAccount(root) {
    root.setAttribute('data-mj-acc', '1');
    var balUrl = root.getAttribute('data-mj-balance-url');
    var opts = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };

    // 残高・有効期限・次ランク
    if (balUrl) {
      fetch(balUrl, opts)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          var b = root.querySelector('[data-mj-balance]');
          if (b) b.textContent = num(d.balance);
          var p = root.querySelector('[data-mj-pending]');
          if (p) p.textContent = num(d.pending);
          if (d.points_expire_at) {
            var ev = root.querySelector('[data-mj-expire]');
            var er = root.querySelector('[data-mj-expire-row]');
            if (ev) ev.textContent = jpDate(d.points_expire_at);
            if (er) er.hidden = false;
          }
          if (d.next_rank && d.next_rank.name) {
            var nr = root.querySelector('[data-mj-next-row]');
            var pill = root.querySelector('[data-mj-next-pill]');
            if (pill) {
              var remain = num(d.next_rank.remaining);
              // ランク名（textContent で XSS 回避）。スタイルは data-mj-next-rank / data-mj-next-remaining に付与。
              var nameSpan = document.createElement('span');
              nameSpan.setAttribute('data-mj-next-rank', '');
              nameSpan.textContent = d.next_rank.name;
              pill.textContent = '';
              if (remain > 0) {
                // 「{name}まであと ¥{remaining}」
                var remainSpan = document.createElement('span');
                remainSpan.setAttribute('data-mj-next-remaining', '');
                remainSpan.textContent = '¥' + remain.toLocaleString();
                pill.appendChild(nameSpan);
                pill.appendChild(document.createTextNode('会員まであと '));
                pill.appendChild(remainSpan);
              } else {
                // しきい値到達・昇格待ち。次回判定(発送後の再計算)で2段以上上がる場合もあり、/balance の next_rank は
                // 「今の1つ上」しか返さない＝確定ランク不明。よってランク名は断言せず「ランクアップ予定」のみ告知。
                pill.appendChild(document.createTextNode('次回のランク更新でランクアップ予定'));
              }
            }
            if (nr) nr.hidden = false;
          }

          // 送料無料クーポン: balance に free_shipping_coupon があれば自動表示し、手動フォールバックを隠す
          var fsAuto = document.querySelector('[data-mj-fs-auto]');
          var fsManual = document.querySelector('[data-mj-fs-manual]');
          if (fsAuto && d.free_shipping_coupon && d.free_shipping_coupon.code) {
            var fs = d.free_shipping_coupon;
            var fsCode = fsAuto.querySelector('[data-mj-fs-code]');
            if (fsCode) fsCode.textContent = fs.code;
            var fsRank = fsAuto.querySelector('[data-mj-fs-rank]');
            if (fsRank && d.rank && d.rank.name) fsRank.textContent = d.rank.name + '会員限定';
            var fsNote = fsAuto.querySelector('[data-mj-fs-note]');
            if (fsNote) {
              var lim = num(fs.monthly_limit);
              var limTxt = lim >= 2 ? ('月' + lim + '回までご利用いただけます') : '月1回までご利用いただけます';
              fsNote.textContent = '有効期限：' + (fs.expires_at ? jpDate(fs.expires_at) : '') + ' ／ ' + limTxt;
            }
            fsAuto.hidden = false;
            if (fsManual) fsManual.hidden = true;
          }
        })
        .catch(function () {});
    }

  }

  // ポイント履歴（ポイント履歴タブ）: /apps/nsn-loyalty/history をライブ取得して描画
  function initHistory(root) {
    root.setAttribute('data-mj-hi', '1');
    var histUrl = root.getAttribute('data-mj-history-url');
    var listEl = root.querySelector('[data-mj-history]');
    var moreBtn = root.querySelector('[data-mj-history-more]');
    var emptyEl = root.querySelector('[data-mj-history-empty]');
    if (!histUrl || !listEl) return;
    var opts = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    fetch(histUrl, opts)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var items = Array.isArray(d) ? d : (d && Array.isArray(d.history)) ? d.history : [];
        if (!items.length) { if (emptyEl) emptyEl.hidden = false; return; }
        var LIMIT = 5;
        var tableEl = root.querySelector('[data-mj-history-table]');
        if (tableEl) tableEl.hidden = false;
        items.forEach(function (it, i) {
          var amt = histAmount(it);
          var tr = document.createElement('tr');
          tr.className = 'mj-loyalty-history__row';
          // cancelled（earn/earn_bonus のみ）は取り消し線・グレーで無効表示
          if (it.status === 'cancelled') tr.className += ' mj-loyalty-history__row--void';
          if (i >= LIMIT) tr.hidden = true;
          // textContent で組み立て（バックエンド文字列の XSS 回避）。data-label はモバイル積み上げ時のラベル。
          var ev = document.createElement('td');
          ev.className = 'mj-loyalty-history__event'; ev.setAttribute('data-label', 'イベント');
          ev.textContent = histLabel(it) + histStatusSuffix(it);
          var pt = document.createElement('td');
          pt.className = 'mj-loyalty-history__point ' + (amt < 0 ? 'is-minus' : 'is-plus'); pt.setAttribute('data-label', 'ポイント');
          pt.textContent = (amt >= 0 ? '+' : '') + amt + 'pt';
          var dt = document.createElement('td');
          dt.className = 'mj-loyalty-history__date'; dt.setAttribute('data-label', '日付');
          dt.textContent = histDate(it);
          tr.appendChild(ev); tr.appendChild(pt); tr.appendChild(dt);
          listEl.appendChild(tr);
        });
        if (items.length > LIMIT && moreBtn) {
          moreBtn.hidden = false;
          moreBtn.addEventListener('click', function () {
            listEl.querySelectorAll('.mj-loyalty-history__row[hidden]').forEach(function (tr) { tr.hidden = false; });
            moreBtn.hidden = true;
          });
        }
      })
      .catch(function () {});
  }

  /* ---- 3) カートのポイント利用（割引コード発行→適用） ---- */
  function initCoupon(root) {
    root.setAttribute('data-mj-cp', '1');
    var balUrl = root.getAttribute('data-mj-balance-url');
    var couponUrl = root.getAttribute('data-mj-coupon-url');
    var balEl = root.querySelector('[data-mj-coupon-balance]');
    var amtEl = root.querySelector('[data-mj-coupon-amount]');
    var applyBtn = root.querySelector('[data-mj-coupon-apply]');
    var msgEl = root.querySelector('[data-mj-coupon-msg]');
    var opts = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    var balance = 0;
    // カートに残す POINT-* 以外のコード（Liquidが算出）。適用/取消の両方で /cart/update.js に渡す。
    var keepCodes = root.getAttribute('data-mj-keep-codes') || '';

    function msg(t) { if (msgEl) { msgEl.textContent = t || ''; msgEl.hidden = !t; } }

    // 保有ポイント取得。0より大きければ利用UIを表示。
    if (balUrl) {
      fetch(balUrl, opts)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return;
          balance = num(d.balance);
          if (balEl) balEl.textContent = balance;
          if (amtEl) amtEl.max = balance;
          if (balance <= 0) {
            if (amtEl) amtEl.disabled = true;
            if (applyBtn) applyBtn.disabled = true;
          }
        })
        .catch(function () {});
    }

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var amt = num(amtEl && toHalf(amtEl.value));
        if (amt <= 0) { msg('使うポイントを入力してください'); return; }
        if (amt > balance) { msg('保有ポイントを超えています'); return; }
        applyBtn.disabled = true;
        msg('適用中...');
        fetch(couponUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ amount: amt })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }, function () { return { ok: r.ok, d: {} }; }); })
          .then(function (res) {
            var d = res.d || {};
            var code = d.code || d.discount_code || d.coupon || d.coupon_code;
            if (res.ok && code) {
              // 適用も /cart/update.js に統一する。旧 /discount/CODE リンクはチェックアウト側に
              // 別管理で焼き付き、取り消しても決済に残るため（Shopify Editions'25 の推奨）。
              // POINT-* 以外の既存コードは残す。
              var applyVal = keepCodes ? (keepCodes + ',' + code) : code;
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ discount: applyVal })
              })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function () { window.location.href = '/cart'; })
                .catch(function () { applyBtn.disabled = false; msg('カートへの反映に失敗しました。時間をおいてお試しください。'); });
            } else if (d.error === 'insufficient_points') {
              // 堤さんアプリの 422：{error:"insufficient_points", available, requested}
              // サーバの最新残高(available)で表示を更新し、不足を明示。
              applyBtn.disabled = false;
              if (d.available != null) {
                balance = num(d.available);
                if (balEl) balEl.textContent = balance;
                if (amtEl) amtEl.max = balance;
              }
              msg('ポイントが不足しています（保有 ' + balance + 'pt）');
            } else {
              applyBtn.disabled = false;
              msg(d.message || d.error || 'ポイントの適用に失敗しました。時間をおいてお試しください。');
            }
          })
          .catch(function () { applyBtn.disabled = false; msg('通信エラーが発生しました。'); });
      });
    }

    // 取り消し: POINT-* コードだけ外す。/cart/update.js の discount は全コード置換なので、
    // 残すコード（POINT-*以外）を Liquid が data 属性で渡す。空文字なら全コード解除。
    var removeBtn = root.querySelector('[data-mj-coupon-remove]');
    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        removeBtn.disabled = true;
        msg('取り消し中...');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: keepCodes })
        })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { removeBtn.disabled = false; msg('取り消しに失敗しました。時間をおいてお試しください。'); });
      });
    }

    // ブラウザバック(bfcache復元)時は最新状態にリロード。決済で✕→戻る で古い「利用中」表示が
    // 残る（＝実データは消えてるのに画面だけ古い）のを防ぐ。カートページ限定・通常読込では発火しない。
    window.addEventListener('pageshow', function (e) { if (e.persisted) window.location.reload(); });
  }

  /* ---- 4) カート獲得予定ポイント（mj-cart-earn / sd-loyalty.js のカート版を移植） ---- */
  function numF(s) { var n = parseFloat(s); return isNaN(n) ? 0 : n; }
  function ceJson(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function ceActive(bonus) { if (!bonus || !bonus.campaigns) return []; var now = new Date(); return bonus.campaigns.filter(function (c) { var s = new Date(c.start), e = new Date(c.end); if (isNaN(s.getTime()) || isNaN(e.getTime())) return false; return now >= s && now < e; }); }
  function ceIncl(arr, v) { return !!arr && v != null && arr.map(Number).indexOf(Number(v)) !== -1; }
  function ceInter(a, b) { if (!a || !b || !a.length || !b.length) return false; var bs = b.map(Number); return a.some(function (x) { return bs.indexOf(Number(x)) !== -1; }); }
  function ceTag(ct, it) { if (!ct || !it || !ct.length || !it.length) return false; var lo = it.map(function (t) { return String(t).toLowerCase(); }); return ct.some(function (t) { return lo.indexOf(String(t).toLowerCase()) !== -1; }); }
  function ceMatch(c, l) { return !!c.all || ceIncl(c.product_ids, l.product_id) || ceInter(c.collection_ids, l.collection_ids) || ceTag(c.tags, l.tags); }
  function ceFmt(ms) { if (ms < 0) ms = 0; var s = Math.floor(ms / 1000); return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60); }

  function initCartEarn(root) {
    root.setAttribute('data-mj-ce', '1');
    var rate = numF(root.getAttribute('data-loyalty-rate'));
    var taxFactor = numF(root.getAttribute('data-loyalty-tax-factor')) || 1;
    var centsDivisor = numF(root.getAttribute('data-loyalty-cents-divisor')) || 1;
    var valueEl = root.querySelector('[data-loyalty-value]');
    if (!rate || !valueEl) return;
    var bonusData = ceJson(root.querySelector('[data-loyalty-campaign-bonus]'));
    // カート行（campaign 判定用。数量変更では構成は変わらないので初期値を使い続ける＝sd-loyalty.js と同じ割り切り）
    var cartLines = ceJson(root.querySelector('[data-loyalty-cart-lines]')) || [];
    var bonusEl = root.querySelector('[data-loyalty-bonus]');
    var bonusNameEl = root.querySelector('[data-loyalty-bonus-name]');
    var bonusValueEl = root.querySelector('[data-loyalty-bonus-value]');
    var campEl = root.querySelector('[data-loyalty-camp]');
    var campBadgeEl = root.querySelector('[data-loyalty-camp-badge]');
    var campLabelEl = root.querySelector('.loyalty-earn-points__camp-label');
    var campCountEl = root.querySelector('[data-loyalty-camp-countdown]');
    var timer = null;
    function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }
    // campaign 対象 line の税抜 line_price を合算
    function matchedNet(c) { var sum = 0; cartLines.forEach(function (l) { if (ceMatch(c, l)) sum += (numF(l.line_price) / centsDivisor) / taxFactor; }); return sum; }

    function render() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var net = (numF(cart.items_subtotal_price) / centsDivisor) / taxFactor;
          valueEl.textContent = Math.floor(net * rate);

          var camps = ceActive(bonusData), bonusPts = 0, label = '', soonest = null, headRate = 0, head = null;
          camps.forEach(function (c) {
            var mn = c.all ? net : matchedNet(c);
            if (!mn || mn <= 0) return;
            bonusPts += Math.floor(mn * numF(c.rate));
            if (!head) head = c;
            if (!label) label = c.label || c.name || '';
            if (!headRate) headRate = numF(c.rate);
            var e = new Date(c.end);
            if (soonest === null || e < soonest) soonest = e;
          });

          if (bonusEl) {
            if (bonusPts > 0) {
              if (bonusNameEl) bonusNameEl.textContent = label ? label + ' ' : '';
              if (bonusValueEl) bonusValueEl.textContent = bonusPts;
              bonusEl.hidden = false;
            } else { bonusEl.hidden = true; }
          }

          if (campEl) {
            if (bonusPts > 0 && soonest) {
              var pct = headRate > 0 ? Math.round(headRate * 100) : 0;
              var prefix = head && head.badge ? head.badge : (label.indexOf('新作') !== -1 ? 'NEW' : '');
              if (campBadgeEl) campBadgeEl.textContent = (prefix ? prefix + ' ' : '') + (pct > 0 ? '+' + pct + '%' : 'POINT');
              if (campLabelEl) campLabelEl.textContent = label || 'ポイントアップキャンペーン';
              campEl.hidden = false;
              stopTimer();
              if (campCountEl) {
                var tick = function () {
                  var d = soonest.getTime() - Date.now();
                  if (d <= 0) { campCountEl.textContent = '00:00:00'; stopTimer(); render(); return; }
                  campCountEl.textContent = '終了まで ' + ceFmt(d);
                };
                tick();
                timer = setInterval(tick, 1000);
              }
            } else { campEl.hidden = true; stopTimer(); }
          }
        })
        .catch(function () {});
    }

    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form[action$="/cart"], [data-cart]')) render(); });
    document.addEventListener('cart:updated', render);
    document.addEventListener('cart:refresh', render);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-mj-countdown]:not([data-mj-cd])').forEach(initCountdown);
    document.querySelectorAll('[data-mj-account]:not([data-mj-acc])').forEach(initAccount);
    document.querySelectorAll('[data-mj-history-root]:not([data-mj-hi])').forEach(initHistory);
    document.querySelectorAll('[data-mj-coupon]:not([data-mj-cp])').forEach(initCoupon);
    document.querySelectorAll('[data-loyalty-cart-earn]:not([data-mj-ce])').forEach(initCartEarn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
